// Stub pages — each shows all students and links to their detail tab
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { supabase, getInitials, daysBetween } from '../lib/supabase'

const AVATAR_COLORS = ['avatar-blue','avatar-green','avatar-purple','avatar-orange','avatar-pink']
const getAvatarColor = (name) => AVATAR_COLORS[(name?.charCodeAt(0)||0) % AVATAR_COLORS.length]

function StudentListPage({ title, subtitle, tab, activeFilter, badge }) {
  const [students, setStudents] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetch = async () => {
      setLoading(true)
      const { data } = await supabase.from('students').select('*').eq('status', activeFilter).order('english_name')
      if (data) setStudents(data)
      setLoading(false)
    }
    fetch()
  }, [activeFilter])

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">{title}</div>
          <div className="page-subtitle">{subtitle} · {activeFilter} students</div>
        </div>
      </div>
      <div className="page-content">
        {loading ? <div className="loading">Loading...</div> : (
          <div style={{display:'flex',flexDirection:'column',gap:8}}>
            {students.map(s => (
              <Link key={s.id} to={`/student/${s.id}#${tab}`} style={{textDecoration:'none'}}>
                <div className={`card ${activeFilter === 'Inactive' ? 'inactive-card' : ''}`}
                  style={{padding:'12px 16px',display:'flex',alignItems:'center',gap:12,cursor:'pointer'}}>
                  <div className={`avatar ${getAvatarColor(s.english_name)}`}>{getInitials(s.english_name)}</div>
                  <div style={{flex:1}}>
                    <div style={{fontWeight:600,fontSize:13}}>{s.english_name}</div>
                    <div style={{fontSize:11,color:'var(--muted)'}}>{s.current_school} · Grade {s.grade_when_joined}</div>
                  </div>
                  {badge && badge(s)}
                  <span style={{fontSize:12,color:'var(--accent)'}}>Open {tab} →</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export function UniversityList({ activeFilter }) {
  return <StudentListPage title="University lists" subtitle="Select and manage university choices" tab="universities" activeFilter={activeFilter}/>
}

export function Applications({ activeFilter }) {
  return <StudentListPage title="College applications" subtitle="Track application status and deadlines" tab="applications" activeFilter={activeFilter}/>
}

export function Activities({ activeFilter }) {
  return <StudentListPage title="Extracurricular activities" subtitle="Track all student activities" tab="activities" activeFilter={activeFilter}/>
}

export function APCourses({ activeFilter }) {
  return <StudentListPage title="AP courses" subtitle="Track AP course selections and scores" tab="ap courses" activeFilter={activeFilter}/>
}

export function SATToefl({ activeFilter }) {
  return <StudentListPage title="SAT / TOEFL scores" subtitle="Track all test attempts and best scores" tab="sat/toefl" activeFilter={activeFilter}
    badge={s => s.mbti_type ? <span className="badge badge-blue">{s.mbti_type}</span> : null}
  />
}

export function Transcripts({ activeFilter }) {
  return <StudentListPage title="Transcripts & GPA" subtitle="Track GPA by school year" tab="transcripts" activeFilter={activeFilter}/>
}

export function MyersBriggs({ activeFilter }) {
  return <StudentListPage title="Myers-Briggs" subtitle="Personality test results" tab="mbti" activeFilter={activeFilter}
    badge={s => s.mbti_type
      ? <span className="badge badge-blue">{s.mbti_type}</span>
      : <span className="badge badge-yellow">Pending</span>
    }
  />
}

export default { UniversityList, Applications, Activities, APCourses, SATToefl, Transcripts, MyersBriggs }
